<ng-persian-datepicker (dateOnSelect)="onDateChange($event)" uiIsVisible="false" 
  uiHideAfterSelectDate="false" uiHideOnOutsideClick="false">
    <input class="text-blueGray-600 border-gray-300 rounded w-full" type="text" [formControl]="dateValue" />
  </ng-persian-datepicker>
  
  
  <!-- [uiTheme]="customTheme" -->